import { Button } from "../App.styles";

const ExternalLinkButton = ({ children, color, href, target, className = '', ...props }) => (
  <Button as="a" href={href} className={`btn btn-${color} ${className}`} target={target} {...props}>
    <div dangerouslySetInnerHTML={{__html: children}} />
  </Button>
);

export default ExternalLinkButton;
